<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { setTrackStorage } from '@/utils/storage'

// 是否点击了afc广告
let isClickAfcInner = false
// 是否点击了穿插广告
let isClickVignetteAdInner = false
// 是否点击了锚定广告
let isClickAnchorAdInner = false
// 是否点击了普通的afc广告
let isClickNormalAfcInner = false

export default {
  name: 'App',

  mounted() {
    this.visibilityChangeListener()
    this.track()
  },

  unmounted() { },

  methods: {
    // 监听页面显隐
    visibilityChangeListener() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          console.log('window hide', `isClickAfcInner: ${isClickAfcInner}`, `isClickVignetteAdInner: ${isClickVignetteAdInner}`, `isClickAnchorAdInner: ${isClickAnchorAdInner}`)

          gtag('event', "page_hidden")

          if (isClickAfcInner) {
            const { pathname } = window.location
            gtag("event", "click_afc", {
              page: pathname === '/history' ? 'history_page' : pathname === '/' ? 'home_page' : 'content_page'
            });

            // 点击普通afc广告事件
            if (isClickNormalAfcInner) {
              ttq.track('AddToCart')
            }

            // 点击锚定广告
            if (isClickAnchorAdInner) {
              ttq.track('CompleteRegistration')
            }

            // 点击穿插广告
            if (isClickVignetteAdInner) {
              ttq.track('AddToWishlist')

              gtag("event", "click_vignette", {
                page: pathname === '/history' ? 'history_page' : pathname === '/' ? 'home_page' : 'content_page'
              });
            }

            isClickVignetteAdInner = false
            isClickAfcInner = false
            isClickAnchorAdInner = false
            isClickNormalAfcInner = false
          }
        } else if ((document.visibilityState === 'visible')) {
          gtag('event', "page_visible")

          // 页面显示后重置点击广告变量
          isClickAfcInner = false
          isClickVignetteAdInner = false
          isClickAnchorAdInner = false
          isClickNormalAfcInner = false
        }
      })
    },

    track() {
      window.focus();
      window.addEventListener('blur', () => {
        const r = document.activeElement;
        console.log('blur element', r);
        if (r && r.tagName.toLowerCase() === 'iframe') {
          isClickAfcInner = true

          // 当前iframe广告的爷爷节点
          const parentNode = r?.parentNode?.parentNode;
          // 判断当前是不是插屏或穿插广告
          const isScreenAd = parentNode?.getAttribute('data-vignette-loaded') == 'true' || parentNode?.getAttribute('data-slotcar-interstitial') == 'true';
          // 判断点击的是不是锚定广告
          const isAnchorAd = parentNode?.getAttribute('data-anchor-shown') == 'true'

          // 点击了穿插或插屏
          if (isScreenAd) {
            isClickVignetteAdInner = true
          }

          // 点击了锚定广告
          if (isAnchorAd) {
            isClickAnchorAdInner = true
          }

          // 点击了普通的afc广告
          if (!isScreenAd && !isAnchorAd) {
            isClickNormalAfcInner = true
          }

          gtag('event', "click_iframe")

          setTimeout(() => {
            isClickAfcInner = false
            isClickVignetteAdInner = false
            isClickAnchorAdInner = false
            isClickNormalAfcInner = false
          }, 2000);
        }
        setTimeout(() => {
          window.focus();
        }, 0);
      })
    }
  }
}
</script>

<style>
@import url('./assets/css/common.css')
</style>
